export const documentDropDowns: any = [
  {
    label: "Select Exchange Type",
    options: [
      {
        _id: "1",
        value: "iex",
        label: "IEX",
      },
      {
        _id: "2",
        value: "hpx",
        label: "HPX",
      },
      {
        _id: "3",
        value: "pxil",
        label: "PXIL",
      },
      {
        _id: "4",
        value: "idt",
        label: "IDT",
      },
      {
        _id: "5",
        value: "dsm",
        label: "DSM",
      },
    ],
  },
  {
    label: "Select Bill Type",
    options: [
      {
        _id: "1",
        value: "dam",
        label: "DAM",
      },
      {
        _id: "2",
        value: "gdam",
        label: "GDAM",
      },
      {
        _id: "3",
        value: "rtm",
        label: "RTM",
      },
      {
        _id: "4",
        value: "tam",
        label: "TAM",
      },
      {
        _id: "5",
        value: "gtam",
        label: "GTAM",
      },
    ],
  },
];


export const taxJuridictionOptions = [
  { value: "CAAB", label: "Alberta (5%)" },
  { value: "CABC", label: "British Columbia (5%)" },
  { value: "CAMB", label: "Manitoba (5%)" },
  { value: "CANB", label: "New Brunswick (15%)" },
  { value: "CANF", label: "Newfoundland & Labrador (15%)" },
  { value: "CANS", label: "Nova Scotia (15%)" },
  { value: "CANW", label: "Northwest Territories (5%)" },
  { value: "CANU", label: "Nunavut (5%)" },
  { value: "CAON", label: "Ontario (13%)" },
  { value: "CAPE", label: "Prince Edward Island (15%)" },
  { value: "CAQC", label: "Quebec (14.975%)" },
  { value: "CASK", label: "Saskatchewan (5%)" },
  { value: "CAYK", label: "Yukon Territory (5%)" },
  { value: "CA00", label: "Federal Level for GST" },

];

export const invoiceTypeOptions = [
  { label: "KG - Vendor Credit Memo", value: "KG" },
  { label: "KR - Vendor Invoice", value: "KR" },
];

export const currencyOptions = [
  { "label": "INR", "value": "INR" },
  { "label": "AUD", "value": "AUD" },
  { "label": "MXN", "value": "MXN" },
  { "label": "NGN", "value": "NGN" },
  { "label": "NZD", "value": "NZD" },
  { "label": "CLP", "value": "CLP" },
  { "label": "DOP", "value": "DOP" },
  { "label": "PEN", "value": "PEN" },
  { "label": "PHP", "value": "PHP" },
  { "label": "ZAR", "value": "ZAR" },
  { "label": "USD", "value": "USD" },
  { "label": "KES", "value": "KES" },
  { "label": "CAD", "value": "CAD" },
  { "label": "EUR", "value": "EUR" },
  { "label": "GBP", "value": "GBP" },
  { "label": "JPY", "value": "JPY" }
]

export const tdsSectionTypeOptions = [
  { label: "Gross Up", value: "grossUp" },
  { label: "Net Up", value: "netUp" },
];